import React from 'react';

export default function AdminFullTable({ columns, data, tableClass }) {
  if (!data || data.length === 0) return <p>No data found.</p>;

  const cols = columns || Object.keys(data[0]).map(k => ({ 
    label: k.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), 
    key: k 
  }));

  return (
    <div style={{ overflowX: 'auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', padding: 24 }}>
      <table className={tableClass} style={{ width: '135%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {cols.map(col => (
              <th key={col.key} style={{ 
                padding: '10px 8px', 
                borderBottom: '1px solid #eee', 
                background: '#f6f6f6', 
                color: '#002071', 
                fontWeight: 600,
                
              }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={row.id || i}>
              {cols.map(col => (
                <td key={col.key} style={{ 
                  padding: '8px', 
                  borderBottom: '1px solid #f0f0f0', 
                  color: '#333',
                  
                }}>
                  <div style={{ display: 'flex',  alignItems: 'center' }}>
                    {row[col.key]}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}